import { getCurrentInstance, inject, onUnmounted } from 'vue';
import eventType from '@teacher/config/event-type';

let allTypes = Object.values(eventType);
if (!allTypes.every((item) => typeof item === 'symbol')) {
  console.error('event-type中定义了非symbol的值');
  allTypes = allTypes.filter((item) => typeof item === 'symbol');
}

const isLegalType = function isLegalType(type) {
  if (typeof type !== 'symbol' || !allTypes.includes(type)) {
    console.error('订阅事件的type必须使用event-type里定义的type');
    return false;
  }
  return true;
};

export default {
  install(application) {
    const { app } = application.config.globalProperties;

    const e = new app.Event();

    function useEvent() {
      if (!getCurrentInstance()) {
        console.error('useEvent必须在setup或生命周期中同步调用');
        return null;
      }

      const offList = [];
      onUnmounted(() => {
        offList.forEach((off) => off());
      });

      // emit方法
      const send = function send(type, ...args) {
        if (!isLegalType(type)) {
          return;
        }
        e.emit(type, ...args);
      };

      // 普通的on方法
      const onImmediate = function onImmediate(type, fn) {
        if (!isLegalType(type)) {
          return;
        }
        const off = e.on(type, fn);
        offList.push(off);
      };

      // page级别的on方法
      let on = onImmediate;
      const useActivePageFlag = inject('useActivePageFlag');
      if (useActivePageFlag) {
        const isActive = useActivePageFlag();
        const usePageShow = inject('usePageShow');
        const delayPageShow = app.tool.delayWrap(usePageShow, { once: true });

        on = function pageOn(type, fn) {
          if (!isLegalType(type)) {
            return;
          }
          // 触发多次消息时,只执行一次.
          const messageQueue = {};
          const off = e.on(type, (...args) => {
            if (isActive.value) {
              fn(...args);
            } else if (!messageQueue[type]) {
              messageQueue[type] = true;
              // 延迟到pageShow事件执行.
              delayPageShow(() => {
                fn(...args);
                messageQueue[type] = false;
              });
            }
          });
          offList.push(off);
        };
      }

      return {
        send,
        // 页面级的订阅,pageshow时才会触发订阅的回调
        on,
        // 普通的订阅
        onImmediate,
      };
    }
    application.provide('useEvent', useEvent);
  },
};
